import Tooltip from 'components/layout/tooltip';

export const PRODUCT_PHOTO_WIDTH = 60;
export const PRODUCT_PHOTO_HEIGHT = 40;

type ProductPhotoProps = Readonly<{
  uniqueId: string;
  center: { x: number; y: number };
  photoUrl: string;
  strokeColor: string;
  name?: string;
  descriptors?: string[];
}>;

export default function ProductPhoto({
  uniqueId,
  center,
  photoUrl,
  strokeColor,
  name,
  descriptors
}: ProductPhotoProps) {
  const left = center.x - PRODUCT_PHOTO_WIDTH / 2;
  const top = center.y - PRODUCT_PHOTO_HEIGHT / 2;
  const trimmedDescriptors =
    descriptors?.filter((d) => typeof d === 'string' && d.length > 0) ?? [];
  const hasTooltip = !!name || trimmedDescriptors.length > 0;
  const clipPathId = `product-photo-clip-${uniqueId}`;

  return (
    <g>
      <g pointerEvents='none'>
        <defs>
          <clipPath id={clipPathId}>
            <rect
              x={left}
              y={top}
              width={PRODUCT_PHOTO_WIDTH}
              height={PRODUCT_PHOTO_HEIGHT}
              rx={6}
              ry={6}
            />
          </clipPath>
        </defs>
        <rect
          x={left}
          y={top}
          width={PRODUCT_PHOTO_WIDTH}
          height={PRODUCT_PHOTO_HEIGHT}
          rx={6}
          ry={6}
          fill='white'
        />
        <image
          href={photoUrl}
          x={left}
          y={top}
          width={PRODUCT_PHOTO_WIDTH}
          height={PRODUCT_PHOTO_HEIGHT}
          preserveAspectRatio='xMidYMid meet'
          clipPath={`url(#${clipPathId})`}
        />
        <rect
          x={left}
          y={top}
          width={PRODUCT_PHOTO_WIDTH}
          height={PRODUCT_PHOTO_HEIGHT}
          rx={6}
          ry={6}
          fill='none'
          stroke={strokeColor}
          strokeWidth={1.5}
        />
      </g>
      {hasTooltip && (
        <foreignObject
          x={left}
          y={top}
          width={PRODUCT_PHOTO_WIDTH}
          height={PRODUCT_PHOTO_HEIGHT}
          style={{ overflow: 'visible' }}
        >
          <div
            style={{
              width: '100%',
              height: '100%',
              position: 'relative',
              pointerEvents: 'auto',
              cursor: 'help'
            }}
          >
            <Tooltip>
              <div className='flex flex-col gap-0.5'>
                {name && <div className='font-medium'>{name}</div>}
                {trimmedDescriptors.length > 0 && (
                  <div className='text-xs text-gray-200'>
                    {trimmedDescriptors.join(' · ')}
                  </div>
                )}
              </div>
            </Tooltip>
          </div>
        </foreignObject>
      )}
    </g>
  );
}
